import React, { useState } from 'react'
import {Dropdown, ListGroup, Modal} from 'react-bootstrap'
import {IVacancyCompany, VacancyCompanyHook} from "../../api/vacancy-company";
import {SelectField} from "../../components/forms/VacancyCreateForm";
import {useStores} from "../../stores";
import Image from './Image'


export const UsersVacancyCompany = () => {

    const {authStore} = useStores()
    const companyId = authStore.user?.company?.id

    const {data: vacancyCompanyList, isLoading, refetch: VacancyCompanyRefetch} = VacancyCompanyHook.useVacancyCompanies(companyId)

    const [selectedVacancyCompany, setSelectedVacancyCompany] = useState<IVacancyCompany | null>(null);
    const { data: list = [], refetch: UsersRefetch } = VacancyCompanyHook.useAllUsers(Number(selectedVacancyCompany))

    const handleSelect = async (key: string, value: any) => {
        setSelectedVacancyCompany(value)
        await UsersRefetch()
    }

    const vacancyCompanyResponse: { id: number; name: string }[] =
        vacancyCompanyList && vacancyCompanyList[0]?.map(({ id, name }) => ({
            id: Number(id),
            name
        })) || [];


    return(
        <>
            <SelectField
                label={"Заказчик"}
                name={'companyVacancy'}
                value={selectedVacancyCompany?.name}
                onChange={handleSelect}
                options={vacancyCompanyResponse}
                className={'items-center gap-4'}
            />
            {selectedVacancyCompany
                ? (
                    <>
                        <table className='table table-bordered'>
                            <thead>
                            <tr>
                                <th>#</th>
                                <th>Фото</th>
                                <th>Имя</th>
                                <th>Почта</th>
                                <th>Роли</th>
                            </tr>
                            </thead>
                            <tbody>
                            {
                                list?.map((item) => {
                                    return (
                                        <tr key={item.id}>
                                            <td>{item.id}</td>
                                            <td><Image path={item.photo} /></td>
                                            <td>{item.fullName}</td>
                                            <td>{item.email}</td>
                                            <td><ListGroup>
                                                {
                                                    item.roles.map((role, index) => {
                                                        return <ListGroup.Item key={index}>{role}</ListGroup.Item>
                                                    })
                                                }
                                            </ListGroup></td>
                                        </tr>
                                    )
                                })
                            }
                            </tbody>
                        </table>
                    </>
                )
                : <div>Выберите заказчика</div>
            }
        </>
    )
}